import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    items: String,
    sourceType: { type: String, default: "collection" },
    sourceId: String,
  }

  static outlets = ["playback-queue"]

  declare readonly itemsValue: string
  declare readonly sourceTypeValue: string
  declare readonly sourceIdValue: string
  declare readonly playbackQueueOutlet: {
    enqueue: (
      items: string,
      startIndex: number,
      sourceType: string,
      sourceId: string,
    ) => void
  }

  playAll() {
    this.playbackQueueOutlet.enqueue(
      this.itemsValue,
      0,
      this.sourceTypeValue,
      this.sourceIdValue,
    )
  }

  playFrom(event: Event) {
    const target = event.target as HTMLElement
    // Links (item titles), forms, and submit buttons inside a row keep
    // their own behavior — only the row surface starts playback.
    if (
      target.closest("a") ??
      target.closest("form") ??
      target.closest("button[type='submit']") ??
      target.closest("[data-queue-ignore]")
    )
      return

    const row = (event.currentTarget as HTMLElement).closest(
      "[data-queue-index]",
    )
    if (!(row instanceof HTMLElement)) return

    const index = parseInt(row.dataset.queueIndex!, 10)
    this.playbackQueueOutlet.enqueue(
      this.itemsValue,
      index,
      this.sourceTypeValue,
      this.sourceIdValue,
    )
  }
}
